import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, DownloadIcon, EyeIcon, GiftIcon, LayersIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const highlights = [{
  icon: LayersIcon,
  label: '6-in-1 Complete Instructor System'
}, {
  icon: BookOpenIcon,
  label: '150 Ready-to-Teach Classes'
}, {
  icon: EyeIcon,
  label: '100% Visual Core Teaching Material'
}, {
  icon: GiftIcon,
  label: '5 Professional Bonus Guides'
}, {
  icon: DownloadIcon,
  label: 'Immediate Digital Access'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-cream px-4 pb-16 pt-14 sm:pb-24 sm:pt-20" data-id="element-148" data-mp="ncgm0kvouzwd">
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-149" data-mp="3d1ilrd3pdip0">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-150" data-mp="3cz5x6h3fwa2z">
          <p className="font-display text-2xl font-semibold text-ink sm:text-3xl" data-id="element-151" data-mp="3j6fylr125fed">
            <ProductName script data-id="element-152" data-mp="3o73pmcpadw8l" />
          </p>
          <Ornament className="mt-4" data-id="element-153" data-mp="39al9qe68qo35" />
          <h1 className="mx-auto mt-6 max-w-4xl text-4xl font-semibold leading-[1.08] text-ink sm:text-5xl lg:text-6xl" data-id="element-154" data-mp="399jojgvigl7p">
            Solve an entire year of Salsa & Bachata classes in just{' '}
            <span className="italic text-burgundy" data-id="element-155" data-mp="30h9blrt8e1mr">5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 w-full sm:mt-10" data-id="element-156" data-mp="359javyg8ke1p">
          <img src="https://cdn.magicpatterns.com/uploads/x7kC2YPZjey3JkCVkT5JZK/Diseno_sin_titulo_(67).png" alt="Salsa & Bachata Instructor Ready: 6-volume box set, Class Finder tablet and the 5 bonus guides" className="mx-auto w-full max-w-2xl drop-shadow-xl" data-id="element-157" data-mp="2hj5fbxyfzx2d" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7 flex flex-col items-center" data-id="element-158" data-mp="nb1k738w7pvw">
          <p className="mx-auto max-w-2xl text-base leading-7 text-ink-muted sm:text-lg" data-id="element-159" data-mp="db2ct9o7m5km">
            The Complete <span className="font-semibold text-burgundy" data-id="element-160" data-mp="1ayt6mzo5djaw">6-in-1</span>{' '}
            Visual Teaching System with 150 Ready-to-Teach Salsa & Bachata
            Classes, Technique Progressions, Partnerwork, Musicality,
            Corrections & Professional Instructor Tools.
          </p>
          <PriceTag className="mt-8" data-id="element-161" data-mp="x0ut1whnhqwg" />
          <div className="mt-7" data-id="element-162" data-mp="3lsoyt0hf3v83">
            <CheckoutButton data-id="element-163" data-mp="3ltqbtahzursg">GET SALSA & BACHATA INSTRUCTOR READY NOW</CheckoutButton>
          </div>
          <ul className="mx-auto mt-10 grid w-full max-w-4xl grid-cols-2 gap-x-4 gap-y-6 border-t border-gold/30 pt-8 sm:grid-cols-3 lg:grid-cols-5" data-id="element-164" data-mp="3hqkbejhkbutw">
            {highlights.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex flex-col items-center gap-2.5 text-xs font-semibold uppercase leading-5 tracking-[0.06em] text-ink" data-id="element-165" data-mp="21bfsnhwi11qr">
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/60 text-gold" data-id="element-166" data-mp="2b2aisxcv8lhh">
                  <Icon size={20} strokeWidth={1.5} aria-hidden="true" data-id="element-167" data-mp="2g1wuv3gyjvop" />
                </span>
                {label}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}